import React, { createRef } from "react";
import DocumentList, { DocList } from "./DocumentList";
import GeneralDetail from "./GeneralDetail";
import Overview from "./Overview";
import ScrutinizedDocument from "./ScrutinizedDocument";
import { Link } from "react-router-dom";
import { callApi } from "../../utils/api";
import AddOnFeature from "./AddOnFeature";
import HintAboutFile from "./HintAboutFile";
import { ADMIN_ROLE, FRONTOFFICE_ROLE } from "../../utils/role";
import Select from "react-select";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import CountdownTimer from "../file/CountdownTimer";
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;
interface AllProps {
  match: any;
  history: any;
  location: any;
}
export default class WorkFile extends React.Component<AllProps> {
  overviewRef = createRef<Overview>();
  state = {
    doc_list: [],
    revenueCount: 0,
    AllDocumentShow: false,
    overVieWorking: false,
    documentTotal: 0,
    overViewShow: false,
    bank_templates: [],
    bank_id: 0,
    intime: 0,
    selectVal: false,
    setResponse: true,
    in_reason: "",
    info: {
      lawhands_branch: "",
      verify_officer: "",
      process_officer: "",
      deviation_officer: "",
      rectify_officer: "",
      app_id: "",
      doc_request: "",
      file_name: "",
      file_status: "",
      verify: "",
      report_status: "",
      pending: "",
      closed: "",
      total: "",
      org_bank_id: "",
      productId: "",
      post_required_status: "",
      taken_status: "",
    },
    wizard: {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
      step7: false,
    },
    id: 0,
    docList: [],
    initialTimeInMinutes: 0,
    updatedRemainingTime: 0,
    isLoading: false,
    tempdocToPreview: "",
    post_disbursal_list: [],
    overviewVisitKey: 0,
  };
  async componentDidMount() {
    this.getPostDisbursal();
    this.getRevenueDocs();
    localStorage.setItem(
      "currentfileId",
      JSON.stringify(this.props.match.params.id),
    );

    this.getTemplates();
    this.getFileDashboard();
    this.setState({ id: this.props.match.params.id });

    // Check if coming specifically from Check page with previousStep
    const previousStep = this.props.location.state?.previousStep;
    const isFromCheckPage = this.props.location.state?.fromCheckPage;

    if (isFromCheckPage && previousStep) {
      // Only go to the previous step if coming from Check page
      this.goToTab(previousStep);
    } else {
      // Otherwise use the normal step from params
      this.goToTab("step" + this.props.match.params.stepno);
    }

    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
    if (!hasHide) {
      this.getInTime();
    }
    localStorage.setItem("dashboard_status", "1");
  }
  componentDidUpdate(prevProps) {
    // Handle tab when location state changes (e.g., when navigating back from Check)
    if (this.props.location.state !== prevProps.location.state) {
      const previousStep = this.props.location.state?.previousStep;
      const isFromCheckPage = this.props.location.state?.fromCheckPage;

      if (isFromCheckPage && previousStep) {
        // Set the tab based on the previous step
        this.goToTab(previousStep);
      }
    }
  }
  countdownTimerRef: CountdownTimer | null = null;
  componentWillUnmount() {
    if (this.countdownTimerRef) {
      this.countdownTimerRef.clearInterval();
    }
  }
  onchange = (e: any) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(),
      selectVal: false,
    });
  };
  previousPop = () => {
    $("#in_time").modal("show");
    $("#another-reason").modal("hide");
  };
  closeToaster = () => {
    $("#alert_alldocs").modal("hide");
  };
  closeToasterOverview = () => {
    $("#alert_overview").modal("hide");
  };
  closeToasterSOP = () => {
    $("#alert_SOP").modal("hide");
  };
  OpenToaster = (notice: any) => {
    if (notice == 2) {
      $("#alert_SOP").modal("show");

      setTimeout(() => {
        $("#alert_SOP").modal("hide");
      }, 5000);
    }
  };
  ShowTheMessage = () => {
    $("#alert_overview").modal("show");

    setTimeout(() => {
      $("#alert_overview").modal("hide");
    }, 5000);
  };

  getRevenueDocs = () => {
    callApi("POST", "rev_list_get.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        let docList: DocList[] = this.state.docList;
        if (response && response.data && response.data.length) {
          docList = response.data;
        }
        this.setState({ docList });
        let arrayValue = response.data;
        let LengthValue = 0;
        arrayValue?.forEach((element) => {
          if (
            element.submit == 0 ||
            (element.submit == 1 && element.inactive == 0)
          ) {
            let revenueCount = LengthValue + 1;
            this.setState({ revenueCount });
          }
          if (this.state.revenueCount == 0) {
            this.setState({ AllDocumentShow: true, overVieWorking: true });
          }
        });
      })

      .catch((err) => {
        console.log(err);
      });
  };

  previousPage = () => {
    const fileurl: any = localStorage.getItem("url");
    $("#in_time").modal("hide");
    localStorage.removeItem("currentfileId");
    localStorage.removeItem("thisPopup");
    this.props.history.push(`${fileurl}`);
    localStorage.removeItem("url");
  };
  getInTime = () => {
    if (localStorage.getItem("thisPopup")) {
      $("#in_time").modal("show");
      let date = new Date();
      let curentDate = date.toLocaleDateString();
      localStorage.setItem("Intimedate", JSON.stringify(curentDate));
      var Railway = date.getMinutes();
      if (Railway < 10) {
        var TotalMinutes = "0" + Railway;
        let intime = date.getHours() + ":" + TotalMinutes;
        localStorage.setItem("IntimeGet", JSON.stringify(intime));
      } else {
        let intime: any = date.getHours() + ":" + date.getMinutes();
        this.setState({ intime: intime });
        localStorage.setItem("IntimeGet", JSON.stringify(intime));
      }
      let intime = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("IntimeGet", JSON.stringify(intime));
    } else {
      $("#in_time").modal("hide");
    }
  };
  SubmitREsponse = () => {
    if (this.state.in_reason == "") {
      this.setState({ selectVal: true });
    } else {
      localStorage.setItem("inreasonlive", this.state.in_reason);
      localStorage.removeItem("thisPopup");
      this.liveinsert();
      localStorage.removeItem("thisPopup");

      let in_reason = this.state.in_reason;
      localStorage.setItem("in_reason", JSON.stringify(in_reason));
      this.processEodInsert();
    }
  };
  processEodInsert = () => {
    const userid1: any = localStorage.getItem("user1");
    const intime: any = localStorage.getItem("IntimeGet");
    let date = new Date();
    let outdate = date.toLocaleDateString();

    let obj = {
      file_id: this.props.match.params.id,
      user_id: JSON.parse(userid1),
      in_reason: this.state.in_reason,
      intime: JSON.parse(intime),
      insert_date: outdate,
    };
    callApi("POST", "process_eod_insert.php", obj)
      .then((res) => res.data)
      .then((response) => {
        if (response.status == 200) {
          const { insert_id } = response;
          localStorage.setItem("ProcessEodInsertID", JSON.stringify(insert_id));
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  };
  liveinsert = () => {
    this.setState({ isLoading: true });
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["team_type"] : "";
    const userId = user ? JSON.parse(user)["userId"] : "";
    const role = user ? JSON.parse(user)["teamType"] : "";
    const role_type = user ? JSON.parse(user)["roleType"] : "";
    const user_name = user ? JSON.parse(user)["userName"] : "";
    const bankName: any = localStorage.getItem("bankName");
    let dateTime = new Date();
    let curentTime = dateTime.toLocaleTimeString();
    const textRay = `Currently working on File No : ${this.props.match.params.id}`;
    let obj = {
      in_time: curentTime,
      reason: this.state.in_reason,
      user_id: userId,
      user_name: user_name,
      team_type: role,
      role_type: role_type,
      working_process: textRay,
      bank_name: bankName,
    };
    callApi("POST", "live_track_insert.php", obj)
      .then((res) => res.data)
      .then((response) => {
        this.setState({ isLoading: false });
        $("#in_time").modal("hide");
        $("#another-reason").modal("hide");
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Your Reason Not Stored");
        this.setState({ isLoading: false });
      });
  };
  onchangeReason = (e: any) => {
    if (e.target.value == "other") {
      this.setState({ in_reason: "", selectVal: false });
      $("#in_time").modal("hide");
      $("#another-reason").modal("show");
    } else if (e.target.value == "select") {
      this.setState({ setResponse: false });
    } else {
      this.setState({ [e.target.name]: e.target.value, selectVal: false });
    }
  };

  getClasses = (modal) => {
    if (this.state.wizard[modal]) {
      return "nav-item active";
    } else {
      return "nav-item";
    }
  };
  goToTab = (modal) => {
    const wizard = {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
      step7: false,
    };
    wizard[modal] = true;
    const nextState: any = { wizard };
    if (modal === "step4") {
      nextState.overviewVisitKey = Date.now();
    }
    this.setState(nextState);
    this.releaseMouseClick();
  };
  releaseMouseClick = () => {
    $("#root").off(".docgenfreeze");
    $("#root").unbind("click mousedown dblclick");
    $(".sw-theme-arrows .content").off(".docgenfreeze");
  };
  stopAllMouseClick = () => {
    this.releaseMouseClick();
    $(".sw-theme-arrows .content").on(
      "click.docgenfreeze mousedown.docgenfreeze dblclick.docgenfreeze",
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      },
    );
  };
  handleChange = (e, propName?, fieldType?) => {
    let fieldName = fieldType === "singleselect" ? propName : e.target.name;
    let fieldValue = fieldType === "singleselect" ? e.value : e.target.value;
    this.setState({ [fieldName]: fieldValue });
    if (fieldName !== "reason") {
      this.saveTemplate(fieldValue);
    }
    if (this.overviewRef.current) {
      localStorage.removeItem("overviewDocument");
      setTimeout(() => {
        this.overviewRef.current?.scrutinyReport();
        if (this.overviewRef.current) {
          this.overviewRef.current.setState({ report: "", timer: 0 });
        }
      }, 1000);
    }
  };

  getFileDashboard = () => {
    callApi("POST", "file_dash.php", {
      branch_idfk: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        const state = response.data;
        const process_officer: any = localStorage.getItem("process_office_id");
        const userid1: any = localStorage.getItem("user1");
        const take_file: any = localStorage.getItem("takenfile_id");
        const getfileId: any = localStorage.getItem("currentfileId");
        if (process_officer == userid1 && take_file == getfileId) {
          if (response.info[0].target_min == 0) {
            $("#balance-time").modal("show");
          } else {
            let initialTimeInMinutes: any = localStorage.getItem(
              "updatedRemainingTime",
            );
            if (initialTimeInMinutes > 0) {
              this.setState(
                (prevState: any) => ({
                  initialTimeInMinutes: initialTimeInMinutes,
                }),
                () => {},
              );
            } else if (response.info) {
              this.setState(
                {
                  initialTimeInMinutes: response.info[0].target_min,
                },
                () => {},
              );
            } else {
              this.setState(
                {
                  initialTimeInMinutes: 0,
                },
                () => {},
              );
            }
          }
        }

        if (response.info && response.info.length) {
          state.info = response.info[0];
          state.bank_id = state.info.bank_id;
          if (state.bank_id == 0) {
            ToastsStore.success("Please Select Your Bank Format");
            this.setState({ overViewShow: true });
          }
        }

        this.setState({ ...state });

        let bankTemp: any = this.state.bank_templates.find((get: any) => {
          if (get.id === this.state.bank_id) {
            localStorage.setItem("bankTemplateName", get.name);
            localStorage.setItem("bankTemplatemode", get.mode);
          }
        });
        $(document).ready(function () {
          $("#simpletable").DataTable();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getPostDisbursal = async (): Promise<void> => {
    callApi("POST", "post_disbursal_get.php", {
      file_id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((result) => {
        if (result.data && result.data.length) {
          this.setState({ post_disbursal_list: result.data });
        } else {
          this.setState({ post_disbursal_list: [] });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  checkPostRequired = () => {
    if (this.state.info.post_required_status === "1") {
      const postDisbursal = this.state.post_disbursal_list;
      if (!postDisbursal || postDisbursal.length === 0) {
        ToastsStore.error(
          "No post disbursal entries found. Please add entries.",
        );
        return false;
      }

      // Check if any entry has empty particular_deed or nature_deed
      const hasEmptyFields = postDisbursal.some(
        (entry: any) =>
          !entry.particular_deed?.trim() || !entry.nature_deed?.trim(),
      );

      if (hasEmptyFields) {
        ToastsStore.error(
          "Please fill in all required fields in post disbursal entries (Particular Deed and Nature of Deed)",
        );
        return false;
      }

      return true;
    }
    return true;
  };

  getTemplates = () => {
    callApi("POST", "file_dash_temp.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ bank_templates: response.data }, () => {
          let bankTemp: any = this.state.bank_templates.find((get: any) => {
            if (get.id === this.state.bank_id) {
              localStorage.setItem("bankTemplateName", get.name);
              localStorage.setItem("bankTemplatemode", get.mode);
            }
          });
        });
        var bankTempName = [];
        bankTempName = response.data;
        localStorage.setItem("BankTemplate", JSON.stringify(bankTempName));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  saveTemplate = (val) => {
    callApi("POST", "bank_temp_save.php", {
      id: this.props.match.params.id,
      bank_id: val,
    })
      .then((res) => res.data)
      .then((response) => {
        localStorage.removeItem("BankTemplate");
        localStorage.removeItem("overviewDocument");
        this.getFileDashboard();
        this.getTemplates();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  updatedRemainingTime(time) {
    this.setState(
      (prevState: any) => ({
        updatedRemainingTime: time,
      }),
      () => {},
    );
  }
  render() {
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    // const role_id = "4";
    const roleType = user ? JSON.parse(user)["roleType"] : "";
    const user_grade = user ? JSON.parse(user)["user_grade"] : "";
    const r_grade = user ? JSON.parse(user)["r_grade"] : "";
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    const VerificationToAddon: any = localStorage.getItem(
      "verification_to_addon",
    );
    const { hash } = this.props.location.state || {};
    const hashCheckList = hash;
    const { selectVal } = this.state;
    const filterTemp =
      role_label !== "Admin" && role_label !== "Super Admin"
        ? this.state.bank_templates.filter(
            (temp: any) =>
              temp?.bank_id === this.state?.info?.org_bank_id &&
              temp?.product_id === this.state?.info?.productId &&
              Array.isArray(temp?.lawhands_branch) &&
              temp.lawhands_branch.includes(this.state?.info?.lawhands_branch),
          )
        : this.state.bank_templates;

    const banktemplatesoption = filterTemp.map((opt: any) => ({
      ...opt,
      label: `${opt.name}-${opt.bank_name}-${opt.product_name}`,
      value: opt.id,
    }));

    const process_officer: any = localStorage.getItem("process_office_id");
    const userid1: any = localStorage.getItem("user1");
    return (
      <section className="pcoded-main-container">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />{" "}
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <div className="row">
                            <div className="col-md-12">
                              {process_officer == userid1 &&
                              this.state.initialTimeInMinutes &&
                              this.state.initialTimeInMinutes > 0 ? (
                                <CountdownTimer
                                  initialTime={this.state.initialTimeInMinutes}
                                  updatedTime={(time) =>
                                    this.updatedRemainingTime(time)
                                  }
                                  ref={(ref) => (this.countdownTimerRef = ref)}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                            <br />
                          </div>
                          <h5>
                            File #{this.state.info.file_name} | PO:
                            {this.state.info.process_officer}
                            {this.state.info.verify_officer != "0" && (
                              <> | VO:{this.state.info.verify_officer}</>
                            )}
                            {this.state.info.deviation_officer != "0" && (
                              <> | DO:{this.state.info.deviation_officer}</>
                            )}
                            {this.state.info.rectify_officer != "0" && (
                              <> | RO:{this.state.info.rectify_officer}</>
                            )}
                          </h5>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-10 d-flex justify-content-end">
                              {/* {
                                VerificationToAddon == "true" && ( */}
                              {/* {this.state.bank_id != 0 &&
                                <div className="d-flex align-items-center">
                                  <p className="pb-0 mb-0">Sample Format Preview</p>
                                  <button
                                    style={{ border: 'none' }}
                                    // type="button"
                                    className="btn float-right"
                                    data-toggle="modal"
                                    data-target="#preview-tempdocToPreview"
                                    onClick={() => {
                                      const filterTemp: any = this.state?.bank_templates?.filter(
                                        (temp: any) => temp?.bank_id === this.state?.info?.org_bank_id &&
                                          temp?.product_id === this.state?.info?.productId && temp?.id === this.state?.bank_id
                                      );
                                      const fileContent = filterTemp && filterTemp[0]?.fileContent;
                                      this.setState({ tempdocToPreview: fileContent });
                                    }
                                    }
                                  >
                                    <FaEye color="black" style={{ height: "25", width: "20px" }} />
                                  </button>
                                </div>
                              } */}
                              <div
                                className="template-select"
                                style={{ width: "20em" }}
                              >
                                <Select
                                  options={banktemplatesoption}
                                  name="bank_id"
                                  value={banktemplatesoption.find(
                                    (o: any) => o.value === this.state.bank_id,
                                  )}
                                  onChange={(e) =>
                                    this.handleChange(
                                      e,
                                      "bank_id",
                                      "singleselect",
                                    )
                                  }
                                />
                              </div>
                              {/* )} */}
                            </div>
                            {VerificationToAddon == "true" ? (
                              <>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => {
                                    this.props.history.push(
                                      "/work-file-verification-list/" +
                                        this.props.match.params.id,
                                    );
                                    localStorage.setItem(
                                      "verification_to_addon",
                                      JSON.stringify(false),
                                    );
                                  }}
                                >
                                  Back To Dashboard
                                </button>
                              </>
                            ) : (
                              <>
                                {hashCheckList == "checkList" ? (
                                  <>
                                    <>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                          const verifiedfile = "checkList";

                                          this.props.history.push({
                                            pathname: `/work-file-details/${this.props.match.params.id}`,
                                            state: { verifiedfile },
                                          });
                                        }}
                                      >
                                        Back To Dashboard
                                      </button>
                                    </>
                                  </>
                                ) : (
                                  <>
                                    <Link
                                      className="btn btn-primary"
                                      to={
                                        "/file-dashboard/" +
                                        this.props.match.params.id
                                      }
                                    >
                                      Back To Dashboard
                                    </Link>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                          <div
                            id="smartwizard"
                            className="sw-main sw-theme-arrows"
                          >
                            {roleType === "10" ||
                            roleType === "9" ||
                            role_id == FRONTOFFICE_ROLE ? (
                              <>
                                <ul className="nav nav-tabs step-anchor">
                                  <li
                                    className={this.getClasses("step7")}
                                    onClick={() => this.goToTab("step7")}
                                  >
                                    <a
                                      className="nav-link"
                                      style={{ paddingTop: "10%" }}
                                    >
                                      <h6 style={{ margin: "13px" }}>
                                        Hint About File{" "}
                                      </h6>
                                    </a>
                                  </li>
                                  <li
                                    className={this.getClasses("step1")}
                                    onClick={() => this.goToTab("step1")}
                                  >
                                    <a className="nav-link">
                                      <h6 style={{ margin: "13px" }}>
                                        Scheduled of <br /> property
                                      </h6>
                                    </a>
                                  </li>
                                  {this.state.AllDocumentShow ? (
                                    <>
                                      {" "}
                                      <li
                                        className={this.getClasses("step2")}
                                        onClick={() => this.goToTab("step2")}
                                      >
                                        <a
                                          className="nav-link"
                                          style={{ paddingTop: "10%" }}
                                        >
                                          <h6 style={{ margin: "13px" }}>
                                            All Documents
                                          </h6>
                                        </a>
                                      </li>
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      {this.state.info.taken_status == "1" ? (
                                        <>
                                          <li
                                            onClick={() => this.OpenToaster(2)}
                                          >
                                            <a
                                              className="nav-link"
                                              style={{ paddingTop: "10%" }}
                                            >
                                              <h6 style={{ margin: "13px" }}>
                                                All Documents
                                              </h6>
                                            </a>
                                          </li>
                                        </>
                                      ) : (
                                        <>
                                          <li
                                            className={this.getClasses("step2")}
                                            onClick={() =>
                                              this.goToTab("step2")
                                            }
                                          >
                                            <a
                                              className="nav-link"
                                              style={{ paddingTop: "10%" }}
                                            >
                                              <h6 style={{ margin: "13px" }}>
                                                All Documents
                                              </h6>
                                            </a>
                                          </li>
                                        </>
                                      )}
                                    </>
                                  )}
                                  <li
                                    className={this.getClasses("step3")}
                                    onClick={() => this.goToTab("step3")}
                                  >
                                    <a className="nav-link">
                                      <h6 style={{ margin: "13px" }}>
                                        List Of <br /> Documents{" "}
                                      </h6>
                                    </a>
                                  </li>
                                </ul>
                              </>
                            ) : (
                              <>
                                <ul className="nav nav-tabs step-anchor">
                                  <li
                                    className={this.getClasses("step7")}
                                    onClick={() => this.goToTab("step7")}
                                  >
                                    <a
                                      className="nav-link"
                                      style={{ paddingTop: "10%" }}
                                    >
                                      <h6 style={{ margin: "13px" }}>
                                        Hint About File{" "}
                                      </h6>
                                    </a>
                                  </li>
                                  <li
                                    className={this.getClasses("step1")}
                                    onClick={() => this.goToTab("step1")}
                                  >
                                    <a className="nav-link">
                                      <h6 style={{ margin: "13px" }}>
                                        Scheduled of <br /> property
                                      </h6>
                                      {/* <p className="m-0">
                                    This is step for general details
                                  </p> */}
                                    </a>
                                  </li>

                                  {this.state.AllDocumentShow ? (
                                    <>
                                      {" "}
                                      <li
                                        className={this.getClasses("step2")}
                                        onClick={() => this.goToTab("step2")}
                                      >
                                        <a
                                          className="nav-link"
                                          style={{ paddingTop: "10%" }}
                                        >
                                          <h6 style={{ margin: "13px" }}>
                                            All Documents
                                          </h6>
                                        </a>
                                      </li>
                                    </>
                                  ) : (
                                    <>
                                      {this.state.info.taken_status == "1" ? (
                                        <>
                                          <li
                                            onClick={() => this.OpenToaster(2)}
                                          >
                                            <a
                                              className="nav-link"
                                              style={{ paddingTop: "10%" }}
                                            >
                                              <h6 style={{ margin: "13px" }}>
                                                All Documents
                                              </h6>
                                            </a>
                                          </li>
                                        </>
                                      ) : (
                                        <>
                                          <li
                                            className={this.getClasses("step2")}
                                            onClick={() =>
                                              this.goToTab("step2")
                                            }
                                          >
                                            <a
                                              className="nav-link"
                                              style={{ paddingTop: "10%" }}
                                            >
                                              <h6 style={{ margin: "13px" }}>
                                                All Documents
                                              </h6>
                                            </a>
                                          </li>
                                        </>
                                      )}
                                    </>
                                  )}

                                  <li
                                    className={this.getClasses("step3")}
                                    onClick={() => this.goToTab("step3")}
                                  >
                                    <a className="nav-link">
                                      <h6 style={{ margin: "13px" }}>
                                        List Of <br /> Documents{" "}
                                      </h6>
                                    </a>
                                  </li>
                                  <li
                                    className={this.getClasses("step6")}
                                    onClick={() => this.goToTab("step6")}
                                  >
                                    <a className="nav-link pt-20">
                                      <h6 style={{ margin: "13px" }}>
                                        Addon Features{" "}
                                      </h6>
                                    </a>
                                  </li>

                                  {/* {(!isEmpty(user_grade) || !isEmpty(r_grade)) && (
                                      <> */}
                                  {this.state.overViewShow ? (
                                    <>
                                      <li
                                        className={this.getClasses("step4")}
                                        onClick={() => this.ShowTheMessage()}
                                      >
                                        <a className="nav-link">
                                          <h6 style={{ margin: "13px" }}>
                                            Documents <br /> Overview{" "}
                                          </h6>
                                        </a>
                                      </li>
                                    </>
                                  ) : (
                                    <li
                                      className={this.getClasses("step4")}
                                      onClick={() =>
                                        this.checkPostRequired()
                                          ? this.goToTab("step4")
                                          : ""
                                      }
                                    >
                                      <a className="nav-link">
                                        <h6 style={{ margin: "13px" }}>
                                          Documents <br /> Overview{" "}
                                        </h6>
                                      </a>
                                    </li>
                                  )}
                                  {/* </>
                                    )} */}
                                </ul>
                              </>
                            )}
                            <div className="content">
                              {this.state.wizard.step1 && (
                                <GeneralDetail
                                  id={this.state.id}
                                  doclist={this.state.docList}
                                />
                              )}
                              {this.state.wizard.step2 && (
                                <DocumentList
                                  id={this.state.id}
                                  doclist={this.state.doc_list}
                                />
                              )}
                              {this.state.wizard.step3 && (
                                <ScrutinizedDocument
                                  id={this.state.id}
                                  history={this.props.history}
                                />
                              )}
                              {/* {this.state.wizard.step4 && (
                                    <PropertyDescription id={this.state.id} />
                                  )}
                                  {this.state.wizard.step5 && (
                                    <CheckList id={this.state.id} />
                                  )} */}
                              {this.state.wizard.step4 && (
                                <Overview
                                  key={`overview-${this.state.overviewVisitKey}`}
                                  ref={this.overviewRef}
                                  id={this.props.match.params.id}
                                  isFinal={false}
                                  history={this.props.history}
                                  fileId={this.props.match.params.id}
                                />
                              )}
                              {this.state.wizard.step5 && (
                                <Overview
                                  id={this.state.id}
                                  isFinal={true}
                                  history={this.props.history}
                                  fileId={this.props.match.params.id}
                                />
                              )}
                              {this.state.wizard.step6 && (
                                <AddOnFeature
                                  id={this.state.id}
                                  isRequired={
                                    this.state.info.post_required_status === "1"
                                  }
                                  refetch={this.getPostDisbursal}
                                />
                              )}
                              {this.state.wizard.step7 && (
                                <HintAboutFile
                                  id={this.state.id}
                                  path="index"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade bd-example-modal-lg"
          id="alert_overview"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog" style={{ maxWidth: "751px" }}>
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <div
                className="modal-body"
                style={{ padding: "32px", paddingBottom: "0px" }}
              >
                <h5 style={{ textAlign: "center" }}>
                  Please Type Your All Documents / Please Type Your Scheduled of
                  property
                </h5>
              </div>
              <div style={{ border: "none" }} className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.closeToasterOverview()}
                  // onClick={this.disableModalHandler}
                  style={{ width: "90px", margin: "auto", fontSize: "17px" }}
                >
                  {" "}
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal hide fade in"
          id="alert_SOP"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog ">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <div
                className="modal-body"
                style={{ padding: "32px", paddingBottom: "0px" }}
              >
                <h5 style={{ textAlign: "center" }}>
                  Please Type Your Scheduled of property
                </h5>
              </div>
              <div style={{ border: "none" }} className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.closeToasterSOP()}
                  // onClick={this.disableModalHandler}
                  style={{ width: "90px", margin: "auto", fontSize: "17px" }}
                >
                  {" "}
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal hide fade in"
          id="alert_alldocs"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog ">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <div
                className="modal-body"
                style={{ padding: "32px", paddingBottom: "0px" }}
              >
                <h5 style={{ textAlign: "center" }}>
                  Please Type Your All Documents
                </h5>
              </div>
              <div style={{ border: "none" }} className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.closeToaster()}
                  // onClick={this.disableModalHandler}
                  style={{ width: "90px", margin: "auto", fontSize: "17px" }}
                >
                  {" "}
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal hide fade in"
          id="in_time"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog ">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <div
                className="modal-body"
                style={{ padding: "30px 23px 29px 24px" }}
              >
                <h5>
                  Please Select a Reason To Open File.No:{" "}
                  {this.props.match.params.id}
                </h5>
                <div
                  className="form-group"
                  style={{ width: "74%", margin: "auto" }}
                >
                  <select
                    className="custom-select"
                    name="in_reason"
                    value={this.state.in_reason.trimStart()}
                    onChange={(e) => this.onchangeReason(e)}
                    required
                    style={{ marginTop: "24px" }}
                  >
                    <option value="select">Select.</option>
                    <option value="New Login">New Login</option>
                    <option value="Manual">Manual</option>
                    <option value="Query Received">Query Received</option>
                    <option value="Previous Login Pending">
                      Previous Login Pending
                    </option>
                    <option value="Previous Query Pending">
                      Previous Query Pending
                    </option>
                    <option value="Re-Assign">Re-Assign</option>
                    <option value="Doubts&Clarification">
                      Doubts/Clarification
                    </option>
                    <option value="Verification">Verification</option>
                    <option value="Data Entry">Data Entry</option>
                    <option value="Vetting">Vetting</option>
                    <option value="other">Others</option>
                  </select>
                  {selectVal ? (
                    <p
                      style={{
                        color: "red",
                        textAlign: "center",
                        fontSize: "16px",
                      }}
                    >
                      Please Select Your Reason{" "}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.SubmitREsponse()}
                  disabled={this.state.isLoading}
                  style={{ width: "76px", fontSize: "17px" }}
                >
                  {" "}
                  {this.state.isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    "OK"
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => this.previousPage()}
                  // onClick={this.disableModalHandler}
                  style={{
                    width: "76px",
                    fontSize: "17px",
                    border: "1px solid black",
                  }}
                >
                  {" "}
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="preview-tempdocToPreview"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ maxWidth: "1200px" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Preview</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <iframe
                  width="100%"
                  height="500px"
                  src={this.state.tempdocToPreview}
                ></iframe>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.setState({ tempdocToPreview: "" });
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal hide fade in"
          id="another-reason"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog ">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                Please Type a Reason To Open File.No:{" "}
                {this.props.match.params.id}{" "}
              </h5>

              <div
                className="modal-body"
                style={{ padding: "30px 23px 29px 24px" }}
              >
                {/* <div className="col-md-5"> */}
                <div
                  className="form-group"
                  style={{ width: "98%", margin: "auto" }}
                >
                  <textarea
                    typeof="text"
                    className="form-control"
                    placeholder="Type Your Reason"
                    name="in_reason"
                    onChange={this.onchange}
                  />
                  {selectVal ? (
                    <p
                      style={{
                        color: "red",
                        textAlign: "center",
                        fontSize: "16px",
                      }}
                    >
                      Please Type Your Reason{" "}
                    </p>
                  ) : null}
                </div>
                {/* </div> */}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.SubmitREsponse()}
                  style={{ width: "76px", fontSize: "17px" }}
                  disabled={this.state.isLoading}
                >
                  {" "}
                  {this.state.isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    "OK"
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => this.previousPop()}
                  style={{
                    width: "76px",
                    fontSize: "17px",
                    border: "1px solid black",
                  }}
                >
                  {" "}
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
